"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeGetTestAttributes = void 0;
var react_1 = __importDefault(require("react"));
var toCamelCase_1 = __importDefault(require("vanillas/toCamelCase"));
var TestAttributeContext_1 = __importDefault(require("./TestAttributeContext"));
var getTestAttributes = function (_a, baseAttr, detail) {
    var appendedScopes = _a.appendedScopes;
    if (baseAttr === void 0) { baseAttr = ''; }
    var attr = {
        'data-cv-test': toCamelCase_1.default("" + (appendedScopes || '') + baseAttr)
    };
    if (detail) {
        attr['data-cv-test-detail'] = detail;
    }
    return attr;
};
var makeGetTestAttributes = function (context) { return function (baseAttr, detail) {
    return getTestAttributes(context, baseAttr, detail);
}; };
exports.makeGetTestAttributes = makeGetTestAttributes;
var withTestFunc = function (Component) { return function (props) { return (react_1.default.createElement(TestAttributeContext_1.default.Consumer, null, function (context) { return (react_1.default.createElement(Component, __assign({}, props, { getTestAttributes: exports.makeGetTestAttributes(context) }))); })); }; };
exports.default = withTestFunc;
